import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import firebaseConfig from "../config/firebase-config";
import { hideLoading, loadingHtml } from "../components/loading";

export function init() {
  const errorMessage = $("#errorMessage");
  const sentOtpBtn = $("#sendOTP");
  const formAccount = $('.form-send-otp');
  const codeOtp = $("#otp");
  const formOTP = $('#formOTP');
  const recaptchaContainer = $("#recaptcha-container");
  let otp;
  let confirmResult;

  firebase.initializeApp(firebaseConfig);

  $(document).ready(() => {
    renderRecaptcha();
    formOTP.hide();

    sentOtpBtn.on('click', () => {
      let account = $('.account').val();
      errorMessage.hide();
      if (validatePhoneNumber(account)) {
        $('.login-register-user').append(loadingHtml());
        account = `+84${account.replace(/^0+/, '')}`
        firebase.auth().signInWithPhoneNumber(account, window.recaptchaVerifier)
          .then((confirmationResult) => {
            hideLoading();
            confirmResult = confirmationResult;
            formOTP.show();
            formAccount.hide();
            toastr["success"]("Đã gửi OTP thành công.");
          })
          .catch((error) => {
            hideLoading();
            console.log(error)
            toastr["info"]("Gửi OTP Không thành công. Vui lòng kiểm tra lại số điện thoại.");
          })
      } else if (validateEmail(account)) {
        formAccount.submit();
      } else {
        toastr["info"]("Vui lòng nhập số điện thoại hoặc email.");
      }
    })

    formOTP.submit((event) => {
      event.preventDefault();
      $('.login-register-user').append(loadingHtml());
      confirmResult.confirm(otp)
        .then(() => {
          toastr["success"]("Xác thực OTP thành công.");
          formAccount.submit();
        })
        .catch((error) => {
          hideLoading();
          toastr["info"]("Mã xác thực OTP không đúng. Vui lòng kiểm tra lại.");
        })
    });

    codeOtp.on('change', () => otp = codeOtp.val());
  });

  function renderRecaptcha() {
    if (recaptchaContainer.length !== 0) {
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
      recaptchaVerifier.render()
        .catch((error) => {
          toastr["info"](error.message);
        });
    }
  }

  function validatePhoneNumber(phone) {
    const regex = /^\+?\d+$/;
    return regex.test(phone);
  }

  function validateEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }
}
